// extracted by mini-css-extract-plugin
export var banner = "_j5-0";
export var closeButton = "_j5-2";
export var greenCheckmark = "_j5-3";
export var hereLink = "_j5-4";
export var titleIcon = "_j5-1";